import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'redux-first-router-link'
import {
  Sidebar,
  SidebarNavigation as BelleSidebarNavigation,
  SidebarLockup,
  Icon,
  SocialNavigation,
} from 'belle-js'
import logout from 'utils/Client/authentication.js'
import classnames from 'classnames'
import styles from './SidebarNavigation.module.scss'

const SidebarSection = (props) => {
  const {
    name,
    onSectionClick,
    children,
    testId,
  } = props

  let sectionName
  if (name) {
    sectionName = (<li data-test-id={testId}>{name}</li>)
    if (onSectionClick) {
      sectionName = (
        <button data-test-id={testId} className={styles.button} onClick={onSectionClick} type="button">
          {name}
        </button>
      )
    }
  }
  return (
    <ul className={styles.heading}>
      {sectionName}
      { children &&
        <ul>
          {
            React.Children.map(children, (child, index) =>
              <li key={index}>{child}</li>)
          }
        </ul>
      }
    </ul>
  )
}

const SidebarDivider = (props) => {
  const {
    isHeaderDivider
  } = props
  const headerDividerStyles = isHeaderDivider ? styles.headerDivider : null
  const dividerStyles = classnames(styles.sidebarDivider, headerDividerStyles)

  return (
    isHeaderDivider ?
      <div className={dividerStyles} /> :
      <li>
        <div className={dividerStyles} />
      </li>
  )
}

const SidebarLogo = () => (
  <a
    href="/"
    style={{ alignSelf: 'flex-start' }}
    data-test-id="sidebar__logoLink">
    <SidebarLockup orientation="horizontal" />
  </a>
)

const handleLogoutOnClick = (e) => {
  logout('marketing')
}

const SidebarNavigation = (props) => {
  const {
    isMobile,
    isNavOpen,
    closeNav,
    navigationLinks,
    contact,
    email,
    phone,
  } = props

  const socialIconSize = 20

  const isOpen = isMobile && isNavOpen

  return (
    <div className={styles.SidebarNavigation} data-test-id="ClientAppSidebar">
      <Sidebar
        isFixed={true}
        isOpen={isOpen}
        closeSidebar={closeNav}
        className="sidebar">
        <SidebarLogo />
        <SidebarDivider isHeaderDivider={true} />
        <BelleSidebarNavigation className={styles.fullNav}>
          <ul className={styles.firstHeading}>
            {navigationLinks}
          </ul>
          <SidebarDivider />
          <SidebarSection
            name="Account"
            testId="accountSectionId">
            <span data-test-id="profileSettingsID">
              <NavLink
                onClick={closeNav}
                to="/settings/login"
                isActive={(match, location) => location.pathname.includes('/settings/')}>
                Profile Settings
              </NavLink>
            </span>
          </SidebarSection>
          <SidebarDivider />
          <SidebarSection
            name={`Contact ${contact}`}
            testId="contactSectionId">
            <span data-test-id="contactTelephoneId">
              <a
                href={`tel:${phone}`}
                onClick={closeNav} >
                {phone}
              </a>
            </span>
            <span data-test-id="emailTelephoneId" className={styles.uppercased}>
              <a
                href={`mailto:${email}`}
                onClick={closeNav} >
                {email}
              </a>
            </span>
          </SidebarSection>
          <SidebarDivider />
          <SidebarSection
            name="Log Out"
            testId="logOutSectionId"
            onSectionClick={handleLogoutOnClick} />
        </BelleSidebarNavigation>
        <div className={styles.socialNavigation}>
          <SocialNavigation layout="inline" faded={true}>
            <li data-test-id="linkedinId">
              <a
                href="https://www.linkedin.com/company/10208395"
                rel="noopener noreferrer"
                onClick={closeNav}
                target="_blank">
                <Icon icon="linkedin" width={socialIconSize} />
              </a>
            </li>
            <li data-test-id="twitterId">
              <a
                href="https://twitter.com/ellevest"
                rel="noopener noreferrer"
                onClick={closeNav}
                target="_blank">
                <Icon icon="twitter" width={socialIconSize} />
              </a>
            </li>
            <li data-test-id="facebookId">
              <a
                href="https://www.facebook.com/ellevesting"
                rel="noopener noreferrer"
                onClick={closeNav}
                target="_blank">
                <Icon icon="facebook" width={10} />
              </a>
            </li>
            <li data-test-id="instagramId">
              <a
                href="https://www.instagram.com/ellevest"
                rel="noopener noreferrer"
                onClick={closeNav}
                target="_blank">
                <Icon icon="instagram" width={socialIconSize} />
              </a>
            </li>
          </SocialNavigation>
        </div>
      </Sidebar>
    </div>
  )
}


SidebarSection.defaultProps = {
  name: null,
  children: [],
  onSectionClick: null,
  testId: '',
}

SidebarSection.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node,
  onSectionClick: PropTypes.func,
  testId: PropTypes.string,
}

SidebarDivider.defaultProps = {
  isHeaderDivider: null,
}

SidebarDivider.propTypes = {
  isHeaderDivider: PropTypes.bool,
}

SidebarNavigation.defaultProps = {
  closeNav () {},
  contact: 'Emily',
  email: 'EGREEN@ELLEVEST.COM',
  phone: '(555) 675-4321'
}

SidebarNavigation.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isNavOpen: PropTypes.bool.isRequired,
  navigationLinks: PropTypes.array.isRequired,
  contact: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  closeNav: PropTypes.func,
}

export default SidebarNavigation



// WEBPACK FOOTER //
// ./src/components/Client/SidebarNavigation/SidebarNavigation.jsx